import * as React from 'react';
import { SpeedDataTimeGroup, CarSpeedDataframeDto} from 'Models/CollisionModel';

type HistoryTimeLineCellsP = {
    speedDataTimeGroup:Array<SpeedDataTimeGroup>;
    activeDataFrameDataTime:string;
    setActiveDataframe:(el:CarSpeedDataframeDto)=>void;
}

export class HistoryTimeLineCells extends  React.Component<HistoryTimeLineCellsP> {
    public shouldComponentUpdate(nextProps:HistoryTimeLineCellsP) {

        if(nextProps.activeDataFrameDataTime !== this.props.activeDataFrameDataTime) {
            return true;
        }

        if(JSON.stringify(nextProps.speedDataTimeGroup) !== JSON.stringify(this.props.speedDataTimeGroup)) {
            return true;
        }

        return false;
    }

    public render() {
        const {activeDataFrameDataTime,setActiveDataframe} = this.props;
        return(
            <div className="historyTimeLine__group2">
                    <div className="historyTimeLine__timeline">
                        {
                            this.props.speedDataTimeGroup.map((speedDataTimeGroupEl,i)=> {
                                return (
                                    <div key={i} className="historyTimeLine__timeline__block">
                                        <div className="historyTimeLine__timeline__second">
                                            {speedDataTimeGroupEl.dateTimeDiff}
                                        </div>
                                        <div className="historyTimeLine__timeline__dataframes">
                                            {
                                                speedDataTimeGroupEl.dataframes.map((el,j) => {
                                                    return <div key={j} 
                                                    className={"historyTimeLine__timeline__dataframe "+((activeDataFrameDataTime==el.dateTime)?"historyTimeLine__timeline__dataframe--active":'')} 
                                                    onClick={()=>setActiveDataframe(el)} />
                                                })
                                            }
                                        </div>
                                    </div>
                                    )
                            })
                        }
                    </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/History/CollisionTimeLine/HistoryTimeLineCells.tsx